<template>
  <div class="webLayout">
    <div v-if="isMobile==='none'"></div>
    <header-index v-else-if="!isMobile" />
    <header-index-app v-else />
    <!-- pageActive != 1 mainPadding: true -->
    <div :class="{ main: true,mainPadding: !isMobile  }">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </div>
    <footer-index v-if="!isMobile" />
     <!-- <footer-index-app v-else /> -->
  </div>
</template>

<script>
import HeaderIndex from "@/layout/components/HeaderIndex.vue";
import FooterIndex from "@/layout/components/FooterIndex.vue";
import HeaderIndexApp from "@/layout/components/HeaderIndexApp.vue";

import { mapGetters } from "vuex";
import deviceMixin from "@/mixins/deviceMixin";
export default {
  name: "WebLayout",
  components: { HeaderIndex, FooterIndex,HeaderIndexApp },
  mixins: [deviceMixin],
  data() {
    return {
      isMobile: 'none',
      cachedViews: [
        "WebIndex",
        "CampusRecruitmentIndex",
        "SocialRecruitment",
        "SpecialRecruitment",
        "PersonnelTraining",
        "AskedQuestion",
      ],
    };
  },
  computed: {
    ...mapGetters(["pageActive"]),

    key() {
      return this.$route.path;
    },
  },

  mounted() {
    // console.log("当前是否移动端:", this.isMobile);
    this.$on("device-change", (isMobile) => {
      console.log("收:", isMobile);
      this.isMobile = isMobile;
      // console.log("当前是否移动端:", this.isMobile);
    });
  },
  created() {},

  beforeDestroy() {
    // 移除监听
    if (this.$parent) {
      this.$parent.$off("device-change");
    }
  },
};
</script>

<style lang="less">
.webLayout {
  .main {
    min-height: calc(100% - 60px);
    background-color: #f6f6f6;
    .bread {
      font-size: 14px;
      & a {
        color: #1961ac;
        font-weight: 600;
      }
    }
  }
  .mainPadding {
    background-color: #fff;
    padding-top: 70px;
    padding-bottom: 40px;
  }
  .el-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 400;
    transition: all 0.3s;
  }
  .el-header,
  .el-main,
  .el-footer {
    padding: 0;
  }
}
</style>
